if (!customElements.get('pillar-cards')) {
  /**
   * Opens the section's native <dialog> from every "Learn more" button and closes it from the close button or a
   * click outside the panel. Escape and the backdrop are the browser's own. Each open starts at the top of the
   * cards, and closing hands focus back to the button that opened it (Safari does not focus a tapped button, so
   * the browser alone would leave focus on the page). After a tap or click it asks for no focus ring, as Safari
   * would otherwise draw one on the button.
   */
  class PillarCards extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-pillar-dialog]');
      if (!this.dialog) return;

      this.scroller = this.dialog.querySelector('[data-pillar-scroller]');
      this.handleClick = this.handleClick.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.addEventListener('click', this.handleClick);
      this.dialog.addEventListener('close', this.handleClose);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.dialog?.removeEventListener('close', this.handleClose);
      if (this.dialog?.open) this.dialog.close();
    }

    handleClick(event) {
      const opener = event.target.closest('[data-pillar-open]');
      if (opener) {
        if (this.dialog.open) return;
        this.opener = opener;
        this.dialog.showModal();
        if (this.scroller) this.scroller.scrollTop = 0;
        return;
      }

      // The dialog fills the viewport and is transparent, so a click that lands on it (not on the panel) is outside
      if (event.target === this.dialog || event.target.closest('[data-pillar-close]')) {
        // A keyboard press on the button fires click with detail 0
        this.closedByPointer = event.detail > 0;
        this.dialog.close();
      }
    }

    handleClose() {
      this.opener?.focus({ preventScroll: true, focusVisible: !this.closedByPointer });
      this.opener = null;
      this.closedByPointer = false;
    }
  }

  customElements.define('pillar-cards', PillarCards);
}
